// extracted by mini-css-extract-plugin
module.exports = {"title":"CoreInfo_title__3v2W3","name":"CoreInfo_name__3QhON","line":"CoreInfo_line__1M-WX","chemicalStructure":"CoreInfo_chemicalStructure__3j57b"};